import { JOB_SERVER_URL } from "../../config";
import http from "../../net/http-common";

export const getGenieProperties = (task_id: string, uid: string) => {
  const params = {
    task_id: task_id,
    uid: uid,
  };
  return http.get(`${JOB_SERVER_URL}/genie_pipeline/genie/results`, {
    params,
    headers: {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
};
